export default __webpack_public_path__ + "static/media/meals.d793f269.svg";